import React from "react";
import { Pressable, StyleSheet, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { t } from "@/localization";
import { openSupport, useSupportStatus } from "./config";

// Chat icon for screen headers. Shows a dot when a reply arrived while the chat was
// closed; renders nothing until the chat can open (signed in, Luna enabled).
export default function SupportButton({ size = 24, color = "#3f5b7a", style }) {
  const { available, unread } = useSupportStatus();
  if (!available) return null;
  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={
        unread ? t("Open support, new reply") : t("Open support")
      }
      onPress={openSupport}
      hitSlop={8}
      style={style}
    >
      <View>
        <Ionicons
          name="chatbubble-ellipses-outline"
          size={size}
          color={color}
        />
        {unread && <View style={s.dot} />}
      </View>
    </Pressable>
  );
}
const s = StyleSheet.create({
  dot: {
    position: "absolute",
    top: 0,
    right: 0,
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: "#F84123",
    borderWidth: 1.5,
    borderColor: "white",
  },
});
